import WebApp from '@twa-dev/sdk';

const makeRandomUUID = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const LOADING_SESSION_ID = makeRandomUUID();

const AL_URL = 'https://api.playdeck.io/api/v1/analytics';
const LS_KEY = 'LOADING_SESSION_ID';

const makeBody = () => {
  return JSON.stringify({
    type: 'early_loading',
    created: Date.now(),
    user_properties: {
      loading_session_id: LOADING_SESSION_ID,
      telegram_id: WebApp?.initDataUnsafe?.user?.id,
    },
    event_properties: {
      name: 'before',
      page_load_start: window.PAGE_LOAD_START,
      platform: WebApp?.platform || 'unknown',
    },
  });
};

const sendBeforeTrackerEvent = (body: any) => {
  return fetch(AL_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  });
};

sendBeforeTrackerEvent(makeBody())
  .then(() => {
    localStorage.setItem(LS_KEY, LOADING_SESSION_ID);
  })
  .catch((err) => {
    console.error(err);
  });
